// Slice-3 stubs — render a "coming with slice N" placeholder so the
// sidebar reads complete without us shipping half-built features. (Users and
// Usage were the Slice-2 stubs here; both have since shipped as real pages.)

import {Link} from "react-router-dom";

const Stub = ({title, slice, blurb}) => (
  <>
    <div className="page-hero">
      <div>
        <div className="adminEnt-eyebrow section-eyebrow">Coming soon</div>
        <h1 className="serif hero-display">{title}</h1>
        <p className="lede">{blurb}</p>
      </div>
    </div>
    <div className="empty">
      Arrives with slice {slice}. For now, manage assignments from the
      {" "}<Link to="/admin/entitlements/skus" style={{color: "var(--navy)"}}>Entitlements</Link>{" "}
      view, or use the <code>plex-ent</code> CLI for bulk operations.
    </div>
  </>
);

export const Contracts = () => (
  <Stub
    title="Contracts"
    slice={3}
    blurb="Contract terms, seat allotments, renewal dates, and invoice history."
  />
);

export const Teams = () => (
  <Stub
    title="Teams"
    slice={3}
    blurb="Group users into teams and grant entitlements at the team level instead of per-user."
  />
);

export const Audit = () => (
  <Stub
    title="Audit"
    slice={3}
    blurb="Immutable log of every grant, revoke, and cap change — who, what, when, why."
  />
);
